import script from "./BeamianPlan.vue?vue&type=script&setup=true&lang=ts"
export * from "./BeamianPlan.vue?vue&type=script&setup=true&lang=ts"

import "./BeamianPlan.vue?vue&type=style&index=0&id=882aa79e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-882aa79e"]])

export default __exports__